import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const CustomTableLoading = () => {
    return(
        <Skeleton count={3}  style={{ height:"80px",width:"100%",marginBottom : "10px" }}/> 
    )
}

export default CustomTableLoading